import { ChangeDetectorRef, Directive, HostBinding, Input, inject } from '@angular/core';
import { Highlightable } from '@angular/cdk/a11y';
import { ResultadoDeBusca } from './busca-global.model';

/**
 * Uma linha da paleta, na forma que o `ActiveDescendantKeyManager` sabe
 * dirigir.
 *
 * `Highlightable` é a interface do CDK: o gerenciador chama `setActiveStyles`
 * na linha que entra e `setInactiveStyles` na que sai
 * (`_activedescendant-key-manager-chunk.mjs`). Não há listener de seta
 * aqui — quem lê a tecla é o gerenciador, no campo.
 *
 * `disabled` existe porque o `ListKeyManager` pula item por
 * `_skipPredicateFn = item => item.disabled` (`_list-key-manager-chunk.mjs`).
 * Sem a propriedade, `undefined` seria falso por acidente; com ela, é falso
 * por decisão.
 *
 * `markForCheck` é obrigatório: o gerenciador escreve daqui de fora, sem
 * evento de template, e o componente é OnPush.
 */
@Directive({ selector: '[mgItemDeBusca]', exportAs: 'mgItemDeBusca' })
export class ItemDeBuscaDirective implements Highlightable {
  private readonly cdr = inject(ChangeDetectorRef);

  @Input({ required: true, alias: 'mgItemDeBusca' }) resultado!: ResultadoDeBusca;

  /** O `id` que o campo aponta por `aria-activedescendant`. */
  @Input({ required: true }) @HostBinding('attr.id') idDoItem!: string;

  readonly disabled = false;

  /**
   * Exposto (não por `@HostBinding('attr.aria-selected')`) porque o
   * `@angular-eslint/template/role-has-required-aria` precisa ENXERGAR
   * `aria-selected` no próprio template do `role="option"` — um host binding
   * de diretiva é invisível para esse lint estático. O template lê este campo
   * por `#refDoItem="mgItemDeBusca"` e `[attr.aria-selected]`.
   */
  @HostBinding('class.mg-paleta__linha--ativa') ativo = false;

  setActiveStyles(): void {
    this.ativo = true;
    this.cdr.markForCheck();
  }

  setInactiveStyles(): void {
    this.ativo = false;
    this.cdr.markForCheck();
  }
}
